import { ApiKeyInfo, ApiKeyStatsDay } from 'common/types';
import { Scopes } from 'common/constants/api';
import { generateSecret, hashSecret } from 'common/utils/apiKeys';
import { api } from 'common/frontend/api';
import { newFirestoreId } from 'common/utils/dataMigrations';
import { FieldValues, Timestamp } from 'common/frontend/firebase/firestore';

export type KeyDetails = {
	secret: string;
	keyId: string;
};

export const createApiKey = async (
	label: string,
	shopId: string,
	scopes: Scopes[],
): Promise<KeyDetails> => {
	const secret = generateSecret();
	const hash = await hashSecret(secret);
	const apiKeyId = newFirestoreId();
	await api()
		.shops.doc(shopId)
		.apiKeys.doc(apiKeyId)
		.set({
			label,
			keyId: apiKeyId,
			shopId,
			hash,
			scopes,
			created: FieldValues.serverTimestamp() as Timestamp,
		});

	return {
		secret,
		keyId: apiKeyId,
	};
};

export const deleteApiKey = async (shopId: string, keyId: string) => {
	return api().shops.doc(shopId).apiKeys.doc(keyId).delete();
};

export const getShopApiKeysQuery = (shopId: string) => {
	return api().shops.doc(shopId).apiKeys;
};

export const getShopApiKeysListener = (
	shopId: string,
	callbacks: { onData: (apiKeyDocs: ApiKeyInfo[]) => void; onError?: (error: Error) => void },
) => {
	const query = getShopApiKeysQuery(shopId);

	const removeListener = query.listenAll((apiKeys) => {
		callbacks.onData(apiKeys);
	}, callbacks.onError);

	return removeListener;
};

export const getShopApiKeysStatsQuery = (shopId: string) => {
	return api().shops.doc(shopId).apiKeyStats;
};

export const getShopApiKeysStatsListener = (
	shopId: string,
	callbacks: {
		onData: (apiKeyDocs: ApiKeyStatsDay[]) => void;
		onError?: (error: Error) => void;
	},
) => {
	const query = getShopApiKeysStatsQuery(shopId);

	const removeListener = query.listenAll((apiKeysStats) => {
		callbacks.onData(apiKeysStats);
	}, callbacks.onError);

	return removeListener;
};
